(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  function initSection(section) {
    var enabled = section.getAttribute('data-parallax') === 'true';
    if (!enabled || prefersReducedMotion) return;

var strength = parseFloat(section.getAttribute('data-parallax-strength')) || 30;
// Convert 0-100 "intensity" into a max pixel offset per section.
var maxOffset = (strength / 100) * 380;

    var bgs = section.querySelectorAll('.parallax-section__bg');
    if (!bgs.length) return;

    var ticking = false;
    var isVisible = false;

function update() {
  ticking = false;
  if (!isVisible) return;

  var rect = section.getBoundingClientRect();
  var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

// Buffer available before the oversized image runs out of coverage.
// CSS gives the image a 30%-of-height buffer on top and bottom
// (top: -30%, height: 160%) — clamp with a small safety margin.
var safeMaxOffset = Math.min(maxOffset, rect.height * 0.27);

  var total = viewportHeight + rect.height;
  var progress = 1 - (rect.top + rect.height / 2) / (total / 2);
  progress = Math.max(-1, Math.min(1, progress));

  var offset = progress * safeMaxOffset;

  for (var i = 0; i < bgs.length; i++) {
    bgs[i].style.transform = 'translate3d(0, ' + offset.toFixed(1) + 'px, 0)';
  }
}

    function requestTick() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          isVisible = entry.isIntersecting;
          if (isVisible) requestTick();
        });
      },
      { rootMargin: '200px 0px 200px 0px' }
    );

    observer.observe(section);
    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick, { passive: true });

    // Initial paint
    requestTick();
  }

  function initAll() {
    var sections = document.querySelectorAll('.parallax-section');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when merchant edits the section in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.parallax-section');
    if (section) initSection(section);
  });
})();